import { Chip, ChipProps } from '@mui/material';
import React from 'react';
import { colors } from '../utils/theme';

interface ColorOverrides {
  backgroundColor?: string;
  borderColor?: string;
  fontColor?: string;
}

export const RootineOutlineChip = ({
  chipProps,
  colorOverrides = {},
}: {
  chipProps: ChipProps;
  colorOverrides?: ColorOverrides;
}): JSX.Element => {
  const { backgroundColor, borderColor, fontColor } = colorOverrides;

  return (
    <Chip
      variant="outlined"
      sx={{
        height: 22,
        py: 0.25,
        border: `1px solid ${borderColor ?? colors.greys.BRAND_BLACK}`,
        background: backgroundColor ?? colors.greys.BASE_WHITE,
        color: fontColor ?? colors.greys.BRAND_BLACK,
        fontSize: 12,
        fontWeight: 500,
      }}
      {...chipProps}
    />
  );
};
